import axios from 'axios'
import { useUserProfileStore } from '../stores/userProfileStore'

const BACKEND_BASE_URL = import.meta.env.VITE_BACKEND_BASE_URL

axios.interceptors.response.use(
  response => {
    handleTokenRefresh(response)
    return response
  },
  error => {
    if (error?.response) {
      handleTokenRefresh(error.response)
    }
    return Promise.reject(error)
  }
)

function handleTokenRefresh(response: any) {
  try {
    const url = response.config?.url ?? ''

    const isFromBackend =
      !!BACKEND_BASE_URL &&
      (url.startsWith(BACKEND_BASE_URL) || response.config?.baseURL === BACKEND_BASE_URL)

    if (!isFromBackend) return

    const newAccessToken = response.headers['x-new-access-token']

    if (!newAccessToken) return

    const userProfileStore = useUserProfileStore()
    userProfileStore.updateIdToken(newAccessToken)
  } catch (err) {
    console.error('Error in Axios response interceptor', err)
  }
}
